import React, { useEffect, useState } from 'react';
import queryString from 'query-string';

import { prepareOptionsForLocationSearch } from "../../src/js/helpers";
import TopMenu from "../SharedComponents/TopMenu";
import Footer from "../SharedComponents/Footer";
import RadioButtons from "../SharedComponents/Forms/RadioButtons";
import AccountInfo from "./AccountInfo";
import SignupForm from "./SignupForm";

import './index.sass';


const SignupPage = ({ categories, footer, regions, topMenu }) => {

  const regionsOptions = prepareOptionsForLocationSearch(regions);

  const [accountType, setAccountType] = useState('basic_plus');
  const [paymentType, setPaymentType] = useState('year');


  useEffect(() => {
    let defaultAccountType = queryString.parse(window.location.search).account_type;
    let defaultPaymentType = queryString.parse(window.location.search).payment_type;

    setAccountType(defaultAccountType || 'basic_plus');
    setPaymentType(defaultPaymentType || 'year');
  }, []);


  const paymentTypeOptions = [
    { label: 'Måned', value: 'month', checked: paymentType === 'month' },
    { label: 'Årlig', value: 'year', checked: paymentType === 'year' },
  ];


  const accountTypeOptions = [
    { label: 'Basic', value: 'basic', checked: accountType === 'basic' },
    { label: 'Basic Plus', value: 'basic_plus', checked: accountType === 'basic_plus' },
    { label: 'Premium', value: 'premium', checked: accountType === 'premium' },
  ];


  return (
    <div className="signup">

      <TopMenu
        { ...topMenu }
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <div className="signup__wrapper container">
        <h1>Opret din annonceringsprofil på Selskabslokaler.dk</h1>

        <div className="row">
          <div className="col-12 col-md-6 col-lg-7 col-xl-6">
            <div className="signup__payment-model-wrapper">
              <p className="signup__payment-model-description">
                Vælg annoncepakke, udfyld nedenstående formular og kom i gang med annonceringen.
              </p>

              <h2>Vælg periode</h2>

              <RadioButtons
                name="paymentType"
                options={paymentTypeOptions}
                handleChange={(value) => setPaymentType(value)}
              />

              <h2>Annoncepakke</h2>

              <RadioButtons
                name="accountType"
                options={accountTypeOptions}
                handleChange={(value) => setAccountType(value)}
              />
            </div>

            <AccountInfo
              accountType={accountType}
              paymentType={paymentType}
            />

            <p className="signup__payment-model-footnote">
              Alle pris er ekskl. moms. Du kan til enhver tid skifte annoncepakke.
            </p>

          </div>

          <div className="col-12 col-md-6 col-lg-5 offset-xl-1">
            <div className="signup__form-wrapper">

              {/*<h2>Udfyld formularen og tilmed dit lokale.</h2>*/}

              <SignupForm
                accountType={accountType}
                paymentType={paymentType}
              />
            </div>

          </div>
        </div>
      </div>

      <Footer { ...footer } />

    </div>
  )
};

export default SignupPage;
